<span class="message">{{ data.message }}</span>
